<h1 mat-dialog-title>Filtri</h1>
<div mat-dialog-content>
  @if (showPlants) {
  <mat-form-field [style.width.%]="100" class="sales-area" appearance="outline">
    <mat-label>Selezione impianti</mat-label>
    <mat-select [formControl]="plantCtrl" name="plant" #singleSelect ngDefaultControl
      (selectionChange)="applyFilters('plant', $event.value)" [(ngModel)]="plantForm" [value]="data.period" multiple>
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Cerca..." [formControl]="plantFilterCtrl"
          noEntriesFoundLabel="Nessun risultato.">
        </ngx-mat-select-search>
      </mat-option>
      @for (plant of filteredPlants | async; track plant) {
      <mat-option [value]="plant.id">
        {{ plant.name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  }

  <mat-form-field [style.width.%]="100" class="sales-area" appearance="outline">
    <mat-label>Periodo</mat-label>
    <mat-select (selectionChange)="applyFilters('period', $event.value)" [value]="data.period">
      @for (product of data.periodList; track product) {
      <mat-option [value]="product.id">
        {{ product.name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (showDatePicker || data.period === 6) {
  <div>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Data inizio</mat-label>
      <input matInput dateInputMask [matDatepicker]="pickerFrom" [value]="data.dates.from"
        (dateChange)="applyFilters('from', $event.value)" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Data fine</mat-label>
      <input matInput dateInputMask [matDatepicker]="pickerTo" [value]="data.dates.to"
        (dateChange)="applyFilters('to', $event.value)" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>
  </div>
  }
</div>

<div mat-dialog-actions class="p-12 d-block text-right">
  <button mat-stroked-button color="warn" class="btn m-r-10" [mat-dialog-close]="reset">
    Reset filtri
  </button>
  <button mat-raised-button color="primary" class="btn" [mat-dialog-close]="results" cdkFocusInitial>
    Applica filtri
  </button>
</div>